import React, { useEffect, useState, useRef } from "react";
import { Outlet, useParams, useLocation, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { validatePartnerAndOperator } from "redux/store/slices/customerSlice";

const PartnerLandingLayout = () => {
  const { partnerId } = useParams();
  const location = useLocation();
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const [loading, setLoading] = useState(true);
  const [validationData, setValidationData] = useState(null);
  const hasValidated = useRef(false);

  useEffect(() => {
    if (hasValidated.current) return;
    hasValidated.current = true;

    const params = new URLSearchParams(location.search);
    const externalCustomerId = params.get("externalCustomerId");
    const token = params.get("token");

    async function checkPartner() {
      if (!partnerId || !token || !externalCustomerId) {
        setLoading(false);
        navigate("/partner-landing/not-found", { replace: true });
        return;
      }

      try {
        const res = await dispatch(
          validatePartnerAndOperator({
            token,
            externalOperatorId: externalCustomerId,
          }),
        ).unwrap();

        setValidationData(res?.data?.[0]);

        setLoading(false);
      } catch (err) {
        console.error("Partner validation failed:", err);

        setLoading(false);

        navigate("/partner-landing/not-found", { replace: true });
      }
    }

    checkPartner();
  }, [partnerId, location.search]);

  if (loading) {
    return (
      <div
        style={{
          position: "fixed",
          inset: 0,
          zIndex: 10000,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          background: "rgba(255,255,255,0.6)",
        }}
      >
        <div className="loader-overlay">
          <div className="spinner"></div>

          <div className="center">
            <img
              src={`${process.env.PUBLIC_URL}/img/loader.png`}
              alt="loader"
            />
          </div>
        </div>
      </div>
    );
  }

  // Wrap Outlet to preserve query params for children if needed
  return (
    <div style={{ minHeight: "100vh" }}>
      <Outlet context={{ validationData }} />
    </div>
  );
};

export default PartnerLandingLayout;
